import { MORTGAGE_URL, PROFILE_URL } from '@/constants/urls';
export const ERRORS_TO_IGNORE = [
  {
    url: MORTGAGE_URL, 
    status: 404,
    method: 'get'
  },
  {
    url: PROFILE_URL,
    status: 404,
    method: 'get'
  }
];